/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_ErrorInputs */

const en_us2_wrapped_error = /** @type {(inputs: Wrapped_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load your retrospective.`)
};

const pt_br2_wrapped_error = /** @type {(inputs: Wrapped_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para carregar sua retrospectiva.`)
};

const es_419_wrapped_error = /** @type {(inputs: Wrapped_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar tu resumen.`)
};

const pt_pt2_wrapped_error = /** @type {(inputs: Wrapped_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar a tua retrospetiva.`)
};

const fr_fr2_wrapped_error = /** @type {(inputs: Wrapped_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger ton bilan.`)
};

const de_de2_wrapped_error = /** @type {(inputs: Wrapped_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Rückblick konnte nicht geladen werden.`)
};

const it_it2_wrapped_error = /** @type {(inputs: Wrapped_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare il tuo riepilogo.`)
};

/**
* | output |
* | --- |
* | "Couldn't load your retrospective." |
*
* @param {Wrapped_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_error = /** @type {((inputs?: Wrapped_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_error(inputs)
	if (locale === "es-419") return es_419_wrapped_error(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_error(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_error(inputs)
	if (locale === "de-DE") return de_de2_wrapped_error(inputs)
	if (locale === "it-IT") return it_it2_wrapped_error(inputs)
	return en_us2_wrapped_error(inputs)
});
export { wrapped_error as "wrapped.error" }